import React, { use, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import "./liquidity.scss";
import {
  callGraphQLQuery,
  callCrashGameGraphQLQuery,
} from "../../utils/axiosClient";
import { useWeb3React } from "@web3-react/core";
import Web3 from "web3";
import TotalLiquidity from "../../hooks/dataFetcher/TotalLiquidity";
import Balance from "../../hooks/dataFetcher/BalanceOf";
import { useCheckAllowance } from "../../hooks/dataSender/Allowance";
import { useApprove } from "../../hooks/dataSender/Approval";
import AddLiquidity from "../../hooks/dataSender/AddLiquidity";
import Loader from "../../hooks/loader";
import RemoveLiquidity from "../../hooks/dataSender/RemoveLiquidity";
import ClaimReward from "../../hooks/dataFetcher/ClaimReward";
import Claim from "../../hooks/dataSender/Claim";
import CountdownTimer from "./CountdownTimer";
import moment from "moment/moment";
import useAuth from "../../hooks/useAuth";
import { Link, useLocation } from "react-router-dom";
import {
  useEthInternalBalace,
  usePermisions,
  userSmartAccount,
  userSmartAccountClient,
  useSmartSession,
} from "../../components/recoilAtom";
import { useRecoilValue } from "recoil";
import { GameAllCalls } from "../../hooks/dataSender/gameEndTime";
import CashOut from "../../hooks/dataSender/cashout";
import {
  getBalance,
  getLiquidityPool,
  CrashGameContract,
} from "../../utils/contractHelpers";
import {
  USDT_CONTRACT_ADDRESS,
  LUCKIFY_CONTRACT_ADDRESS,
  CRASH_GAME_CONTRACT,
} from "../../utils/Enviroment";
import { toast } from "react-toastify";
import showToast from "../../hooks/showToast";
import { useSessionPermissions } from "../../hooks/checkSessionPermissions";
const Liquidity = () => {
  const { AddLiqudityHood, WithDrawHook, claimLiqudityHook, rewardBeteHook } =
    CashOut();
  let { account } = useWeb3React();
  const smartAccount = useRecoilValue(userSmartAccount);
  const session = useRecoilValue(useSmartSession);
  const permission = useRecoilValue(usePermisions);
  const meClient = useRecoilValue(userSmartAccountClient);
  const { login, logout } = useAuth();
  const { TotalLiquidityHook, TotalRewardhook, TotalVolumeHook } =
    TotalLiquidity();
  const ethinternalBlce = useRecoilValue(useEthInternalBalace);
  const { AddLiquidityHook } = AddLiquidity();
  const { RemoveLiquidityHook } = RemoveLiquidity();
  const { ClaimRewardHook } = ClaimReward();
  const { ClaimHook } = Claim();
  const { BalanceHook } = Balance();
  const { grantPermissions } = useSessionPermissions();
  const {
    checkAllowance,
    TotalRewards,
    TotalLiquidityYouProvide,
    CurrentLiquidityYouProvide,
    TotalYourReward,
    TotalShare,
  } = useCheckAllowance();
  const approvee = useApprove();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [theme, setTheme] = useState("light");
  const handleShow = (index, amount) => {
    setShow(true);
    const formattedAmount = parseFloat(
      Web3.utils.fromWei(amount, "mwei")
    ).toFixed(2);
    setWithdrawalAmount(formattedAmount);
    setIndex(index);
  };
  const [liquidityAmount, setLiquidityAmount] = useState(null);
  const [errorState, setErrorState] = useState(false);
  const [errorStateRemove, setErrorStateRemove] = useState(false);
  const [removeUserLiquidity, setRemoveUserLiquidity] = useState("");
  const [userClaims, setUserClaims] = useState(0);
  const [withdrawalAmount, setWithdrawalAmount] = useState(null);
  const [index, setIndex] = useState(null);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const [isTimerExpired, setIsTimerExpired] = useState(false);
  const [loaderText, setLoaderText] = useState({
    heading: "Loading",
    paragraph: "",
  });
  const [userLiquidity, setUserLiquidity] = useState("");
  const [currentUserLiquidity, setCurentUserLiquidity] = useState("");

  const [userRewards, setUserRewards] = useState(0);
  const [userFeeRate, setUserFeeRate] = useState(0);
  // const [timeLockLiqudity, setTimeLockLiqudity] = useState(0);
  // const [totalPatformShare, setTotalPatformShare] = useState(0);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => {
    setShow2(false);
    setShow8(false);
    setTimeout(() => {
      fetchData();
      fetchYourData();
      fetchDepositedHistory();
      fetchRewardsHistory();
      fetchWithdrawldHistory();
    }, 3000);
  };
  const handleShow2 = () => setShow2(true);

  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const [show4, setShow4] = useState(false);
  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);

  const [show5, setShow5] = useState(false);
  const handleClose5 = () => {
    setShow5(false);
    setShow8(false);
    setTimeout(() => {
      fetchData();
      fetchYourData();
      fetchDepositedHistory();
      fetchRewardsHistory();
      fetchWithdrawldHistory();
    }, 3000);
  };
  const handleShow5 = () => setShow5(true);

  const [show6, setShow6] = useState(false);
  const handleClose6 = () => setShow6(false);
  const handleShow6 = () => setShow6(true);

  const [show7, setShow7] = useState(false);
  const handleClose7 = () => setShow7(false);
  const handleShow7 = () => setShow7(true);

  const [show8, setShow8] = useState(false);
  const handleClose8 = () => {
    setShow8(false);
    setShow8(false);
    setTimeout(() => {
      fetchData();
      fetchYourData();
      fetchDepositedHistory();
      fetchRewardsHistory();
      fetchWithdrawldHistory();
    }, 3000);
  };
  const [show11, setShow11] = useState(false);

  const handleClose11 = () => setShow11(false);
  const handleShow11 = () => setShow11(true);
  const handleShow8 = () => setShow8(true);

  const [show9, setShow9] = useState(false);
  const handleClose9 = () => setShow9(false);
  const handleShow9 = () => setShow9(true);

  const [show10, setShow10] = useState(false);
  const handleClose10 = () => {
    setShow10(false);
    setShow8(false);
    setTimeout(() => {
      fetchData();
      fetchYourData();
      fetchDepositedHistory();
      fetchRewardsHistory();
      fetchWithdrawldHistory();
    }, 3000);
  };
  const handleShow10 = () => setShow10(true);

  const [deposittedHistory, setDeposittedHistory] = useState([]);
  const [rewardsHistory, setRewardsHistory] = useState([]);
  const [withdrawlHistory, setWithdrawlHistory] = useState([]);
  const [currentLiquidity, setCurrentLiquidity] = useState(null);
  const [TotalReward, setTotalReward] = useState(null);
  const [userBalance, setUserBalance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalVolume, setTotalVolume] = useState(null);

  const fetchEthBalance = async () => {
    try {
      const balance = await BalanceHook(smartAccount);
      setUserBalance(balance);
    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  };
  useEffect(() => {
    if (smartAccount) {
      fetchEthBalance();
    }
  }, [smartAccount]);

  const connectWallet = async () => {
    try {
      if (account) {
        const connectorId = window.localStorage.getItem("connectorId");
        const res = await logout(connectorId);

        localStorage.clear();
      } else {
        await login("injected");
        localStorage.setItem("connectorId", "injected");
        localStorage.setItem("flag", "true");
        handleClose11();
      }
    } catch (error) {
      console.error("Error in connectWallet:", error);
      localStorage.clear();
    }
  };

  const trustWallet = async () => {
    try {
      if (account) {
        await logout("walletconnect");
      } else {
        setTimeout(() => {}, 3000);
        await login("walletconnect");
        localStorage.setItem("connectorId", "walletconnect");
        localStorage.setItem("flag", "true");
        handleClose11();
      }
    } catch (error) {
      console.error("Error during WalletConnect operation:", error);
    }
  };

  const fetchDepositedHistory = async () => {
    setLoading(true);
    const query = `
    query MyQuery {
      depositeds(orderDirection: desc, orderBy: blockTimestamp, where: {user: "${smartAccount}"}) {
    user
    transactionHash
    amount
    blockTimestamp
  }
    }`;

    try {
      const data = await callCrashGameGraphQLQuery(query);
      const updated = data.depositeds;

      setDeposittedHistory(updated);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch bet history:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchRewardsHistory = async () => {
    setLoading(true);
    const query = `
    query MyQuery {
    rewardClaimeds(orderDirection: desc ,orderBy: blockTimestamp,where: { user: "${smartAccount}" }){
     user
     amount
     transactionHash
    blockTimestamp
   }
   }`;

    try {
      const data = await callCrashGameGraphQLQuery(query);
      const updated = data.rewardClaimeds;
      setRewardsHistory(updated);
    } catch (error) {
      console.error("Failed to fetch bet history:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchWithdrawldHistory = async () => {
    setLoading(true);
    const query = `
    query MyQuery {
  requestSets(orderBy: blockTimestamp, orderDirection: desc, where: { claimer: "${smartAccount}" }) {
    amount
    blockTimestamp
    claimer
    index
    status
    transactionHash
  }
}`;

    try {
      const data = await callCrashGameGraphQLQuery(query);
      const updated = data?.requestSets;
      setWithdrawlHistory(updated);
    } catch (error) {
      console.error("Failed to fetch bet history: updated", error);
    } finally {
      setLoading(false);
    }
  };

  function formatTimestamp(unixSeconds) {
    const date = new Date(unixSeconds * 1000);
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    };
    return date.toLocaleString("en-GB", options).replace(",", "");
  }

  function shortenAddress(address, chars = 4) {
    if (!address) return "";
    return `${address?.slice(0, 2 + chars)}...${address?.slice(-chars)}`;
  }

  useEffect(() => {
    if (smartAccount) {
      fetchDepositedHistory();
      fetchRewardsHistory();
      fetchWithdrawldHistory();
    }
  }, [smartAccount]);

  const fetchData = async () => {
    try {
      const liquidity = await TotalLiquidityHook(
        CrashGameContract,
        CRASH_GAME_CONTRACT
      );
      const reward = await TotalRewardhook(
        CrashGameContract,
        CRASH_GAME_CONTRACT
      );
      const totalvalume = await TotalVolumeHook(
        CrashGameContract,
        CRASH_GAME_CONTRACT
      );
      setTotalVolume(totalvalume * 0.03);
      setCurrentLiquidity(liquidity);
      setTotalReward(reward);
    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchYourData = async () => {
    try {
      const userLiquidity = await TotalLiquidityYouProvide(
        CrashGameContract,
        CRASH_GAME_CONTRACT,
        smartAccount
      );
      const totalRewardss = await TotalRewards(
        CrashGameContract,
        CRASH_GAME_CONTRACT,
        smartAccount
      );
      const userCurrentLiquidity = await CurrentLiquidityYouProvide(
        getLiquidityPool,
        LUCKIFY_CONTRACT_ADDRESS,
        smartAccount
      ); //lp share
      const userReward = await TotalYourReward(
        getLiquidityPool,
        LUCKIFY_CONTRACT_ADDRESS,
        smartAccount
      );
      const TotalSharess = await TotalShare(
        getLiquidityPool,
        LUCKIFY_CONTRACT_ADDRESS,
        smartAccount
      ); //total share
      const liquidity = await TotalLiquidityHook(
        CrashGameContract,
        CRASH_GAME_CONTRACT
      ); //total liqi ;

      const totalSharsValue = Web3.utils.fromWei(String(TotalSharess), "mwei");

      let final = (liquidity * userCurrentLiquidity) / totalSharsValue;
      const formattedclaimable = Web3.utils.fromWei(
        String(userReward?.claimable),
        "mwei"
      );
      const formattedclaimed = Web3.utils.fromWei(
        String(userReward?.claimed),
        "mwei"
      );
      // let value = userCurrentLiquidity / totalSharsValue;
      // let value2 = totalSharsValue * 0.025;
      // let value3 = (value2 * value) / 100;
      // setUserFeeRate(value3);
      // setTotalPatformShare(totalSharsValue);
      // console.log(final, "finalfinalfinal");

      let finalTotalRewardss = Web3.utils.fromWei(
        String(totalRewardss),
        "mwei"
      );
      // setUserFeeRate((finalTotalRewardss / liquidity) * 100);

      setUserLiquidity(final);
      // old liqudity setUserLiquidity(userLiquidity);
      setCurentUserLiquidity(userCurrentLiquidity);
      setUserRewards(formattedclaimable);
      setUserClaims(formattedclaimed);
    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  };

  useEffect(() => {
    if (smartAccount) {
      fetchYourData();
    }
  }, [smartAccount]);

  const liquidityInputHandler = (event) => {
    setErrorState(false);
    let value = event.target.value;
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setLiquidityAmount(value);
    }
  };

  const removeLiquidityinputHandler = (event) => {
    setErrorStateRemove(false);
    const value = event.target.value;
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setRemoveUserLiquidity(value);
    }
  };

  const handleAddLiquidity = async () => {
    setLoading(true);
    const betAmount = parseFloat(liquidityAmount);
    try {
      const checkUserAllowance = await checkAllowance(
        smartAccount,
        CRASH_GAME_CONTRACT
      );
      const { userPermissions: permissions, userSessionKey: sessionKey } =
        await grantPermissions();
      if (checkUserAllowance < betAmount) {
        setLoaderText({
          heading: "Making your deposit.",
          paragraph: "Please approve transaction for making Deposit...",
        });
        const liquidityTx = await AddLiqudityHood(
          betAmount,
          true,
          smartAccount,
          meClient,
          permissions,
          sessionKey
        );
        setLoaderText({
          heading: "",
          paragraph: "",
        });
        setLoading(false);
        handleShow8();
        handleClose7();
        return liquidityTx;
      } else {
        setLoaderText({
          heading: "Making your deposit.",
          paragraph: "Please approve transaction for placing bet...",
        });
        const liquidityTx = await AddLiqudityHood(
          betAmount,
          false,
          smartAccount,
          meClient,
          permissions,
          sessionKey
        );
        setLoaderText({
          heading: "",
          paragraph: "",
        });
        setLoading(false);
        handleShow8();
        handleClose7();
      }
    } catch (error) {
      setLoaderText({
        heading: "",
        paragraph: "",
      });
      setLoading(false);
      console.error("Error placing bet:", error);
    }
  };

  const handleRemoveLiquidity = async () => {
    setLoading(true);
    const betAmount = parseFloat(removeUserLiquidity);
    try {
      setLoaderText({
        heading: "Removing Liquidity",
        paragraph: "Please wait while we remove your liquidity...",
      });
      const { userPermissions: permissions, userSessionKey: sessionKey } =
        await grantPermissions();
      const removeLiquidityTx = await WithDrawHook(
        betAmount,
        false,
        smartAccount,
        meClient,
        permissions,
        sessionKey
      );
      setLoaderText({
        heading: "",
        paragraph: "",
      });
      setLoading(false);
      handleShow5();
      handleClose4();
    } catch (error) {
      setLoaderText({
        heading: "",
        paragraph: "",
      });
      setLoading(false);
      console.error("Error placing bet:", error);
    }
  };

  const handleClaimRewards = async () => {
    setLoading(true);
    try {
      setLoaderText({
        heading: "Claiming Rewards",
        paragraph: "Please wait while we claim your rewards...",
      });
      const { userPermissions: permissions, userSessionKey: sessionKey } =
        await grantPermissions();

      const claimRewardsTx = await rewardBeteHook(
        smartAccount,
        meClient,
        permissions,
        sessionKey
      );
      setLoaderText({
        heading: "",
        paragraph: "",
      });
      if (claimRewardsTx) {
        setLoading(false);
        handleShow10();
        handleClose9();
      }
    } catch (error) {
      setLoaderText({
        heading: "",
        paragraph: "",
      });
      setLoading(false);
      console.error("Error placing bet:", error);
    }
  };

  const handleWidhrawl = async () => {
    setLoading(true);
    try {
      const { userPermissions: permissions, userSessionKey: sessionKey } =
        await grantPermissions();
      setLoaderText({
        heading: "Withdrawing Funds",
        paragraph: "Please wait while we Withdrawing your Funds...",
      });
      const withdrawlTx = await claimLiqudityHook(
        index,
        smartAccount,
        meClient,
        permissions,
        sessionKey
      );
      setLoaderText({
        heading: "",
        paragraph: "",
      });
      setLoading(false);
      handleShow2();
      handleClose1();
    } catch (error) {
      setLoaderText({
        heading: "",
        paragraph: "",
      });
      setLoading(false);
      console.error("Error placing bet:", error);
    }
  };
  // useEffect(() => {
  //   if (
  //     userClaims &&
  //     totalPatformShare &&
  //     timeLockLiqudity &&
  //     currentUserLiquidity
  //   ) {
  //     calculatingAPY();
  //   }
  // }, [userClaims, totalPatformShare, timeLockLiqudity, currentUserLiquidity]);
  const location = useLocation();
  // const calculatingAPY = async () => {
  //   let currentDate = new Date();
  //   currentDate = currentDate?.getTime() / 1000;
  //   let finalDate = currentDate - timeLockLiqudity;
  //   finalDate = finalDate / 86400;
  //   console.log(finalDate, "finalDate", currentUserLiquidity);
  //   let finalValue =
  //     (parseFloat(userClaims) / parseFloat(currentUserLiquidity)) *
  //     (365 / parseFloat(finalDate));
  //   console.log(finalValue, "finalDate");
  //   finalValue = finalValue * 100;
  //   console.log(finalValue, "finalDate");
  // };

  useEffect(() => {
    // fetchCrashGameWinningsBets();
    fetchPlayerBetHistory();
    // let currentDate = new Date();
    // currentDate = currentDate?.getTime() / 1000;
    // const yesterdayEpoch = currentDate - 86400;
  });

  const fetchPlayerBetHistory = async () => {
    const currentEpoch = Date.now() / 1000; // your current epoch time

    // Convert to date and get start of day (12:00 AM)
    const currentDate = new Date(currentEpoch * 1000);
    const startOfDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate()
    );
    const startOfDayEpoch = Math.floor(startOfDay.getTime() / 1000);

    // End of day (11:59 PM) = start of day + 86399 seconds
    const endOfDayEpoch = startOfDayEpoch + 86399;

    const placedBetsQuery = `
  query getCurrentPlayers{
  crashBetPlaceds(where: {    blockTimestamp_gte: "${startOfDayEpoch}",
    blockTimestamp_lte: "${endOfDayEpoch}"}) {
    amount
  }
}
  `;

    try {
      const data = await callCrashGameGraphQLQuery(placedBetsQuery);

      // console.log(data.crashBetPlaceds, "datadatadatadata"); d
      fetchOwnerBetHistory1(
        data.crashBetPlaceds,
        startOfDayEpoch,
        endOfDayEpoch
      );

      // ✅ Sort by blockTimestamp descending to get the latest on top
    } catch (error) {
      console.error("Failed to fetch bet history: datadatadatadata", error);
      setLoading(false);
    }
  };
  const fetchOwnerBetHistory1 = async (
    dataPre,
    startOfDayEpoch,
    endOfDayEpoch
  ) => {
    // setLoading(true);
    const query = `
       query betPlaceds{
  betPlaceds(where:  {    blockTimestamp_gte: "${startOfDayEpoch}",
    blockTimestamp_lte: "${endOfDayEpoch}"}) {
    amount
  }
}
      `;

    try {
      const data = await callGraphQLQuery(query);
      let addd = data.betPlaceds;
      let finalArry = dataPre.concat(addd);
      const total = finalArry.reduce(
        (sum, item) => sum + parseInt(item.amount),
        0
      );
      const totalSharsValue = Web3.utils.fromWei(String(total), "mwei");
      setUserFeeRate(totalSharsValue * 0.015 * 365);
    } catch (error) {
      console.error("Failed to fetch bet history: datadatadata", error);
      setLoading(false);
    }
  };
  return (
    <>
      {loading && <Loader text={loaderText} />}
      <div className="custom-container">
        <div className="mainodds">
          <p className="oddspara">Liquidity</p>
          {/* <div className="navlinks">
            <Link
              to="/play"
              className={
                location.pathname === "/play" ? "navlink active" : "navlink"
              }
            >
              Play
            </Link>
            <Link
              to="/liquidity"
              className={
                location.pathname === "/liquidity"
                  ? "navlink active"
                  : "navlink"
              }
            >
              Liquidity
            </Link>
          </div> */}
        </div>
        <section className="liquidity_main">
          <div className="inner_main">
            <div className="left_side">
              <div className="left_top">
                <div className="inner_left_side">
                  <h2>Total Liquidity</h2>
                  <h3>${(+currentLiquidity)?.toFixed(2)}</h3>
                </div>
                <div className="inner_right_side">
                  <h2>Total Rewards</h2>
                  <h3>${(+totalVolume)?.toFixed(2)}</h3>
                </div>
              </div>
              <div className="flow_mains">
                <div>
                  <h4>Earn with Liquidity</h4>
                  <p>
                    Provide liquidity, earn a share of every bet — passive
                    rewards, Just 7 days of lock-in.
                  </p>
                </div>
                <div className="parents_innar">
                  <div className="inar">
                    <h5>your liquidity stake worth</h5>
                    <h6>${(+userLiquidity)?.toFixed(2)}</h6>
                  </div>
                  <div className="inar">
                    <h5>Your Rewards to date</h5>
                    <h6>${(+userClaims)?.toFixed(2)}</h6>
                  </div>
                  <div className="inar">
                    <h5>Your Claimable Rewards</h5>
                    <h6>${(+userRewards)?.toFixed(2)}</h6>
                  </div>
                  <div className="inar">
                    <h5>Estimated APY </h5>
                    <h6>{(+userFeeRate)?.toFixed(2)}%</h6>
                  </div>
                </div>
                <div className="butttonsdiv">
                  {account ? (
                    <>
                      <button className="addbutton" onClick={handleShow6}>
                        Add Liquidity
                      </button>
                      <button
                        className="claimbutton"
                        disabled={+userRewards === 0}
                        onClick={() => {
                          handleShow9();
                        }}
                      >
                        Claim Rewards
                      </button>
                    </>
                  ) : (
                    <button onClick={handleShow11} className="claimbutton">
                      Connect your Wallet
                    </button>
                  )}
                </div>
                {account && (
                  <button className="removebutton" onClick={handleShow3}>
                    Remove Liquidity
                  </button>
                )}
              </div>
            </div>
            <div className="right__side">
              <h2>History</h2>
              <div>
                <nav className="navsectiontabs">
                  <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <button
                      class="nav-link active"
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="true"
                    >
                      Liquidity deposit
                    </button>
                    <button
                      class="nav-link"
                      id="nav-profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-profile"
                      type="button"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="false"
                    >
                      Rewards{" "}
                    </button>
                    <button
                      class="nav-link"
                      id="nav-contact-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-contact"
                      type="button"
                      role="tab"
                      aria-controls="nav-contact"
                      aria-selected="false"
                    >
                      Liquidity withdrawal{" "}
                    </button>
                  </div>
                </nav>
                <div class="tab-content" id="nav-tabContent">
                  <div
                    class="tab-pane fade show active"
                    id="nav-home"
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                  >
                    <div className="table_side">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Date & Time</th>
                            <th>Tx Hash</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {account ? (
                            deposittedHistory &&
                            deposittedHistory?.length > 0 ? (
                              deposittedHistory?.map((bet, index) => (
                                <tr key={index}>
                                  <td>
                                    {formatTimestamp(bet?.blockTimestamp)}
                                  </td>

                                  <td>
                                    {shortenAddress(bet?.transactionHash)}
                                    <a
                                      href={`https://basescan.org/tx/${bet?.transactionHash}`}
                                      className="innerlink"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                      >
                                        <g clip-path="url(#clip0_175_238)">
                                          <path
                                            d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5"
                                            stroke="#3E3F43"
                                            stroke-width="1.04"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                          <path
                                            d="M10.5 1.5L6 6"
                                            stroke="#3E3F43"
                                            stroke-width="1.04"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                          <path
                                            d="M7.5 1.5H10.5V4.5"
                                            stroke="#3E3F43"
                                            stroke-width="1.04"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_175_238">
                                            <rect
                                              width="12"
                                              height="12"
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </a>
                                  </td>

                                  <td>
                                    {parseFloat(
                                      Web3.utils.fromWei(bet?.amount, "mwei")
                                    ).toFixed(2)}{" "}
                                    USDC
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={3}>
                                  <div className="connectwalletmain w-100">
                                    <span className="mainimg">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="38"
                                        height="38"
                                        viewBox="0 0 38 38"
                                        fill="none"
                                      >
                                        <path
                                          d="M3.16797 3.16699L34.8346 34.8337"
                                          stroke="#F24CA2"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M13.2188 4.25882C16.0856 3.13913 19.2166 2.87923 22.2288 3.51092C25.241 4.14262 28.0038 5.63851 30.1792 7.81563C32.3546 9.99275 33.8484 12.7567 34.4778 15.7694C35.1071 18.7821 34.8448 21.9129 33.7229 24.7788"
                                          stroke="#F24CA2"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M30.2118 30.21C28.7397 31.6821 26.992 32.8498 25.0686 33.6465C23.1452 34.4433 21.0837 34.8533 19.0018 34.8533C16.9199 34.8533 14.8584 34.4433 12.935 33.6465C11.0115 32.8498 9.26389 31.6821 7.79177 30.21C6.31965 28.7379 5.15191 26.9902 4.3552 25.0668C3.5585 23.1434 3.14844 21.0819 3.14844 19C3.14844 16.9181 3.5585 14.8566 4.3552 12.9332C5.15191 11.0098 6.31965 9.2621 7.79177 7.78998"
                                          stroke="#F24CA2"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </svg>
                                    </span>
                                    <h6 className="connecthead">
                                      No Liquidity Deposits Yet
                                    </h6>
                                    <p className="connectpara">
                                      Add liquidity to see your deposit history
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            )
                          ) : (
                            // Address does NOT exist
                            <tr>
                              <td colSpan={3}>
                                <div className="connectwalletmain w-100">
                                  <span className="mainimg">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="38"
                                      height="38"
                                      viewBox="0 0 38 38"
                                      fill="none"
                                    >
                                      <path
                                        d="M30.0833 11.0833V6.33333C30.0833 5.91341 29.9165 5.51068 29.6196 5.21375C29.3227 4.91681 28.9199 4.75 28.5 4.75H7.91667C7.07681 4.75 6.27136 5.08363 5.6775 5.6775C5.08363 6.27136 4.75 7.07681 4.75 7.91667C4.75 8.75652 5.08363 9.56197 5.6775 10.1558C6.27136 10.7497 7.07681 11.0833 7.91667 11.0833H31.6667C32.0866 11.0833 32.4893 11.2501 32.7863 11.5471C33.0832 11.844 33.25 12.2467 33.25 12.6667V19M33.25 19H28.5C27.6601 19 26.8547 19.3336 26.2608 19.9275C25.667 20.5214 25.3333 21.3268 25.3333 22.1667C25.3333 23.0065 25.667 23.812 26.2608 24.4058C26.8547 24.9997 27.6601 25.3333 28.5 25.3333H33.25C33.6699 25.3333 34.0727 25.1665 34.3696 24.8696C34.6665 24.5727 34.8333 24.1699 34.8333 23.75V20.5833C34.8333 20.1634 34.6665 19.7607 34.3696 19.4637C34.0727 19.1668 33.6699 19 33.25 19Z"
                                        stroke="#F24CA2"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M4.75 7.9165V30.0832C4.75 30.923 5.08363 31.7285 5.6775 32.3223C6.27136 32.9162 7.07681 33.2498 7.91667 33.2498H31.6667C32.0866 33.2498 32.4893 33.083 32.7863 32.7861C33.0832 32.4892 33.25 32.0864 33.25 31.6665V25.3332"
                                        stroke="#F24CA2"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </span>
                                  <h6 className="connecthead">
                                    You Haven’t Connected Your Wallet Yet
                                  </h6>
                                  {account ? (
                                    <button className="disconnectbtn">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                      >
                                        <path
                                          d="M10 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V3.33333C14 2.97971 13.8595 2.64057 13.6095 2.39052C13.3594 2.14048 13.0203 2 12.6667 2H10"
                                          stroke="#FF3434"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M5.33594 11.3337L2.0026 8.00033L5.33594 4.66699"
                                          stroke="#FF3434"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M2 8H10"
                                          stroke="#FF3434"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </svg>
                                      Disconnect
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                    <div className="d-none phonebarr">
                      {deposittedHistory?.map((row) => (
                        <div className="card_phonee">
                          <div className="inner_cards">
                            <div>
                              <h2>Date & Time</h2>
                              <h3>{formatTimestamp(row?.blockTimestamp)}</h3>
                            </div>
                            <div>
                              <h2>Tx Hash</h2>
                              <h3>
                                {shortenAddress(row?.transactionHash)}
                                <a
                                  href={`https://basescan.org/tx/${row?.transactionHash}`}
                                  className="innerlink"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                  >
                                    <path
                                      d="M12.25 7.58333V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V2.91667C1.75 2.60725 1.87292 2.3105 2.09171 2.09171C2.3105 1.87292 2.60725 1.75 2.91667 1.75H6.41667"
                                      stroke="#3E3F43"
                                      stroke-width="1.04"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M12.25 1.75L7 7"
                                      stroke="#3E3F43"
                                      stroke-width="1.04"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M8.75 1.75H12.25V5.25"
                                      stroke="#3E3F43"
                                      stroke-width="1.04"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </a>
                              </h3>
                            </div>
                          </div>
                          <div className="lasstdiv">
                            <h2>Amount</h2>
                            <h3>
                              $
                              {parseFloat(
                                Web3.utils.fromWei(row?.amount, "mwei")
                              ).toFixed(2)}
                            </h3>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="nav-profile"
                    role="tabpanel"
                    aria-labelledby="nav-profile-tab"
                  >
                    <div className="table_side ">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Date & Time</th>
                            <th>Tx Hash</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {account ? (
                            rewardsHistory && rewardsHistory.length > 0 ? (
                              rewardsHistory.map((bet, index) => (
                                <tr>
                                  <td>
                                    {formatTimestamp(bet?.blockTimestamp)}
                                  </td>

                                  <td>
                                    {shortenAddress(bet?.transactionHash)}
                                    <a
                                      href={`https://basescan.org/tx/${bet?.transactionHash}`}
                                      className="innerlink"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                      >
                                        <g clip-path="url(#clip0_175_238)">
                                          <path
                                            d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5"
                                            stroke="#3E3F43"
                                            stroke-width="1.04"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                          <path
                                            d="M10.5 1.5L6 6"
                                            stroke="#3E3F43"
                                            stroke-width="1.04"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                          <path
                                            d="M7.5 1.5H10.5V4.5"
                                            stroke="#3E3F43"
                                            stroke-width="1.04"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_175_238">
                                            <rect
                                              width="12"
                                              height="12"
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </a>
                                  </td>
                                  <td>
                                    {parseFloat(
                                      Web3.utils.fromWei(bet?.amount, "mwei")
                                    ).toFixed(2)}{" "}
                                    USDC
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={3}>
                                  <div className="connectwalletmain w-100">
                                    <span className="mainimg">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="38"
                                        height="38"
                                        viewBox="0 0 38 38"
                                        fill="none"
                                      >
                                        <path
                                          d="M3.16797 3.16699L34.8346 34.8337"
                                          stroke="#F24CA2"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M13.2188 4.25882C16.0856 3.13913 19.2166 2.87923 22.2288 3.51092C25.241 4.14262 28.0038 5.63851 30.1792 7.81563C32.3546 9.99275 33.8484 12.7567 34.4778 15.7694C35.1071 18.7821 34.8448 21.9129 33.7229 24.7788"
                                          stroke="#F24CA2"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M30.2118 30.21C28.7397 31.6821 26.992 32.8498 25.0686 33.6465C23.1452 34.4433 21.0837 34.8533 19.0018 34.8533C16.9199 34.8533 14.8584 34.4433 12.935 33.6465C11.0115 32.8498 9.26389 31.6821 7.79177 30.21C6.31965 28.7379 5.15191 26.9902 4.3552 25.0668C3.5585 23.1434 3.14844 21.0819 3.14844 19C3.14844 16.9181 3.5585 14.8566 4.3552 12.9332C5.15191 11.0098 6.31965 9.2621 7.79177 7.78998"
                                          stroke="#F24CA2"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </svg>
                                    </span>
                                    <h6 className="connecthead">
                                      You Haven’t Claimed Any Rewards Yet
                                    </h6>
                                    <p className="connectpara">
                                      Your claimed rewards will show up here
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            )
                          ) : (
                            // Address does NOT exist
                            <tr>
                              <td colSpan={3}>
                                <div className="connectwalletmain w-100">
                                  <span className="mainimg">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="38"
                                      height="38"
                                      viewBox="0 0 38 38"
                                      fill="none"
                                    >
                                      <path
                                        d="M30.0833 11.0833V6.33333C30.0833 5.91341 29.9165 5.51068 29.6196 5.21375C29.3227 4.91681 28.9199 4.75 28.5 4.75H7.91667C7.07681 4.75 6.27136 5.08363 5.6775 5.6775C5.08363 6.27136 4.75 7.07681 4.75 7.91667C4.75 8.75652 5.08363 9.56197 5.6775 10.1558C6.27136 10.7497 7.07681 11.0833 7.91667 11.0833H31.6667C32.0866 11.0833 32.4893 11.2501 32.7863 11.5471C33.0832 11.844 33.25 12.2467 33.25 12.6667V19M33.25 19H28.5C27.6601 19 26.8547 19.3336 26.2608 19.9275C25.667 20.5214 25.3333 21.3268 25.3333 22.1667C25.3333 23.0065 25.667 23.812 26.2608 24.4058C26.8547 24.9997 27.6601 25.3333 28.5 25.3333H33.25C33.6699 25.3333 34.0727 25.1665 34.3696 24.8696C34.6665 24.5727 34.8333 24.1699 34.8333 23.75V20.5833C34.8333 20.1634 34.6665 19.7607 34.3696 19.4637C34.0727 19.1668 33.6699 19 33.25 19Z"
                                        stroke="#F24CA2"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M4.75 7.9165V30.0832C4.75 30.923 5.08363 31.7285 5.6775 32.3223C6.27136 32.9162 7.07681 33.2498 7.91667 33.2498H31.6667C32.0866 33.2498 32.4893 33.083 32.7863 32.7861C33.0832 32.4892 33.25 32.0864 33.25 31.6665V25.3332"
                                        stroke="#F24CA2"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </span>
                                  <h6 className="connecthead">
                                    You Haven’t Connected Your Wallet Yet
                                  </h6>
                                  {account ? (
                                    <button className="disconnectbtn">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                      >
                                        <path
                                          d="M10 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V3.33333C14 2.97971 13.8595 2.64057 13.6095 2.39052C13.3594 2.14048 13.0203 2 12.6667 2H10"
                                          stroke="#FF3434"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M5.33594 11.3337L2.0026 8.00033L5.33594 4.66699"
                                          stroke="#FF3434"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M2 8H10"
                                          stroke="#FF3434"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </svg>
                                      Disconnect
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                    <div className="d-none phonebarr">
                      {rewardsHistory?.map((reward) => (
                        <div className="card_phonee">
                          <div className="inner_cards">
                            <div>
                              <h2>Date & Time</h2>
                              <h3>{formatTimestamp(reward?.blockTimestamp)}</h3>
                            </div>
                            <div>
                              <h2>Tx Hash</h2>
                              <h3>
                                {shortenAddress(reward?.transactionHash)}
                                <a
                                  href={`https://basescan.org/tx/${reward?.transactionHash}`}
                                  className="innerlink"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                  >
                                    <g clip-path="url(#clip0_175_238)">
                                      <path
                                        d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5"
                                        stroke="#3E3F43"
                                        stroke-width="1.04"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M10.5 1.5L6 6"
                                        stroke="#3E3F43"
                                        stroke-width="1.04"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M7.5 1.5H10.5V4.5"
                                        stroke="#3E3F43"
                                        stroke-width="1.04"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_175_238">
                                        <rect
                                          width="12"
                                          height="12"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </a>
                              </h3>
                            </div>
                          </div>
                          <div className="lasstdiv">
                            <h2>Amount</h2>
                            <h3>
                              {parseFloat(
                                Web3.utils.fromWei(reward?.amount, "mwei")
                              ).toFixed(2)}{" "}
                              USDC
                            </h3>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="nav-contact"
                    role="tabpanel"
                    aria-labelledby="nav-contact-tab"
                  >
                    <div className="table_side">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Date & Time</th>
                            <th>Tx Hash</th>
                            <th>Amount</th>
                            <th>Status to Withdraw</th>
                          </tr>
                        </thead>
                        <tbody>
                          {account ? (
                            withdrawlHistory && withdrawlHistory.length > 0 ? (
                              withdrawlHistory.map((bet, index) => (
                                <tr>
                                  <td>
                                    {formatTimestamp(bet?.blockTimestamp)}
                                  </td>
                                  <td>
                                    {shortenAddress(bet?.transactionHash)}
                                    <a
                                      href={`https://basescan.org/tx/${bet?.transactionHash}`}
                                      className="innerlink"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                      >
                                        <g clip-path="url(#clip0_175_238)">
                                          <path
                                            d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5"
                                            stroke="#3E3F43"
                                            stroke-width="1.04"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                          <path
                                            d="M10.5 1.5L6 6"
                                            stroke="#3E3F43"
                                            stroke-width="1.04"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                          <path
                                            d="M7.5 1.5H10.5V4.5"
                                            stroke="#3E3F43"
                                            stroke-width="1.04"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_175_238">
                                            <rect
                                              width="12"
                                              height="12"
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </a>
                                  </td>
                                  <td>
                                    {parseFloat(
                                      Web3.utils.fromWei(bet?.amount, "mwei")
                                    ).toFixed(2)}{" "}
                                    USDC
                                  </td>
                                  <td>
                                    <div>
                                      {parseInt(Date.now() / 1000) <
                                        parseInt(bet.blockTimestamp) +
                                          7 * 24 * 60 * 60 &&
                                      !isTimerExpired ? (
                                        <CountdownTimer
                                          setIsTimerExpired={setIsTimerExpired}
                                          epochTime={
                                            parseInt(bet?.blockTimestamp) +
                                            7 * 24 * 60 * 60
                                          }
                                        />
                                      ) : (
                                        <>
                                          {bet?.status ? (
                                            <button
                                              className="purple_button"
                                              onClick={() =>
                                                handleShow(
                                                  bet?.index,
                                                  bet?.amount
                                                )
                                              }
                                            >
                                              Withdraw
                                            </button>
                                          ) : (
                                            <button className="simple_button">
                                              <svg
                                                class="theme-img light-img"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="14"
                                                height="14"
                                                viewBox="0 0 14 14"
                                                fill="none"
                                              >
                                                <path
                                                  d="M11.6673 3.5L5.25065 9.91667L2.33398 7"
                                                  stroke="#13151A"
                                                  stroke-width="1.5"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                />
                                              </svg>
                                              <svg
                                                class="theme-img dark-img"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="14"
                                                height="14"
                                                viewBox="0 0 14 14"
                                                fill="none"
                                              >
                                                <path
                                                  d="M11.6673 3.5L5.25065 9.91667L2.33398 7"
                                                  stroke="white"
                                                  stroke-width="1.5"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                />
                                              </svg>
                                              Withdrawn
                                            </button>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4}>
                                  <div className="connectwalletmain w-100">
                                    <span className="mainimg">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="38"
                                        height="38"
                                        viewBox="0 0 38 38"
                                        fill="none"
                                      >
                                        <path
                                          d="M3.16797 3.16699L34.8346 34.8337"
                                          stroke="#F24CA2"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M13.2188 4.25882C16.0856 3.13913 19.2166 2.87923 22.2288 3.51092C25.241 4.14262 28.0038 5.63851 30.1792 7.81563C32.3546 9.99275 33.8484 12.7567 34.4778 15.7694C35.1071 18.7821 34.8448 21.9129 33.7229 24.7788"
                                          stroke="#F24CA2"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M30.2118 30.21C28.7397 31.6821 26.992 32.8498 25.0686 33.6465C23.1452 34.4433 21.0837 34.8533 19.0018 34.8533C16.9199 34.8533 14.8584 34.4433 12.935 33.6465C11.0115 32.8498 9.26389 31.6821 7.79177 30.21C6.31965 28.7379 5.15191 26.9902 4.3552 25.0668C3.5585 23.1434 3.14844 21.0819 3.14844 19C3.14844 16.9181 3.5585 14.8566 4.3552 12.9332C5.15191 11.0098 6.31965 9.2621 7.79177 7.78998"
                                          stroke="#F24CA2"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </svg>
                                    </span>
                                    <h6 className="connecthead">
                                      You Haven’t Withdrawn Any Liquidity Yet
                                    </h6>
                                    <p className="connectpara">
                                      You will see your withdrawal requests here
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            )
                          ) : (
                            // Address does NOT exist
                            <tr>
                              <td colSpan={4}>
                                <div className="connectwalletmain w-100">
                                  <span className="mainimg">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="38"
                                      height="38"
                                      viewBox="0 0 38 38"
                                      fill="none"
                                    >
                                      <path
                                        d="M30.0833 11.0833V6.33333C30.0833 5.91341 29.9165 5.51068 29.6196 5.21375C29.3227 4.91681 28.9199 4.75 28.5 4.75H7.91667C7.07681 4.75 6.27136 5.08363 5.6775 5.6775C5.08363 6.27136 4.75 7.07681 4.75 7.91667C4.75 8.75652 5.08363 9.56197 5.6775 10.1558C6.27136 10.7497 7.07681 11.0833 7.91667 11.0833H31.6667C32.0866 11.0833 32.4893 11.2501 32.7863 11.5471C33.0832 11.844 33.25 12.2467 33.25 12.6667V19M33.25 19H28.5C27.6601 19 26.8547 19.3336 26.2608 19.9275C25.667 20.5214 25.3333 21.3268 25.3333 22.1667C25.3333 23.0065 25.667 23.812 26.2608 24.4058C26.8547 24.9997 27.6601 25.3333 28.5 25.3333H33.25C33.6699 25.3333 34.0727 25.1665 34.3696 24.8696C34.6665 24.5727 34.8333 24.1699 34.8333 23.75V20.5833C34.8333 20.1634 34.6665 19.7607 34.3696 19.4637C34.0727 19.1668 33.6699 19 33.25 19Z"
                                        stroke="#F24CA2"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M4.75 7.9165V30.0832C4.75 30.923 5.08363 31.7285 5.6775 32.3223C6.27136 32.9162 7.07681 33.2498 7.91667 33.2498H31.6667C32.0866 33.2498 32.4893 33.083 32.7863 32.7861C33.0832 32.4892 33.25 32.0864 33.25 31.6665V25.3332"
                                        stroke="#F24CA2"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </span>
                                  <h6 className="connecthead">
                                    You Haven’t Connected Your Wallet Yet
                                  </h6>
                                  {account ? (
                                    <button className="disconnectbtn">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                      >
                                        <path
                                          d="M10 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V3.33333C14 2.97971 13.8595 2.64057 13.6095 2.39052C13.3594 2.14048 13.0203 2 12.6667 2H10"
                                          stroke="#FF3434"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M5.33594 11.3337L2.0026 8.00033L5.33594 4.66699"
                                          stroke="#FF3434"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M2 8H10"
                                          stroke="#FF3434"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </svg>
                                      Disconnect
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                    <div className="d-none phonebarr">
                      {withdrawlHistory.map((row) => (
                        <div className="card_phonee">
                          <div className="inner_cards">
                            <div>
                              <h2>Date & Time</h2>
                              <h3>{formatTimestamp(row?.blockTimestamp)}</h3>
                            </div>
                            <div>
                              <h2>Tx Hash</h2>
                              <h3>
                                {shortenAddress(row?.transactionHash)}{" "}
                                <a
                                  href={`https://basescan.org/tx/${row?.transactionHash}`}
                                  className="innerlink"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                  >
                                    <path
                                      d="M12.25 7.58333V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V2.91667C1.75 2.60725 1.87292 2.3105 2.09171 2.09171C2.3105 1.87292 2.60725 1.75 2.91667 1.75H6.41667"
                                      stroke="#3E3F43"
                                      stroke-width="1.04"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M12.25 1.75L7 7"
                                      stroke="#3E3F43"
                                      stroke-width="1.04"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M8.75 1.75H12.25V5.25"
                                      stroke="#3E3F43"
                                      stroke-width="1.04"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </a>
                              </h3>
                            </div>
                          </div>
                          <div className="inner_cards lasstdiv">
                            <div className=" ">
                              <h2>Amount</h2>
                              <h3>
                                $
                                {parseFloat(
                                  Web3.utils.fromWei(row?.amount, "mwei")
                                ).toFixed(2)}
                              </h3>
                            </div>
                            <div>
                              {parseInt(Date.now() / 1000) <
                                parseInt(row.blockTimestamp) +
                                  7 * 24 * 60 * 60 &&
                                !isTimerExpired && (
                                  <>
                                    <h2>Status to Withdraw</h2>

                                    <CountdownTimer
                                      setIsTimerExpired={setIsTimerExpired}
                                      epochTime={
                                        parseInt(row?.blockTimestamp) +
                                        7 * 24 * 60 * 60
                                      }
                                    />
                                  </>
                                )}
                            </div>
                          </div>
                          {parseInt(Date.now() / 1000) <
                            parseInt(row.blockTimestamp) + 7 * 24 * 60 * 60 &&
                          !isTimerExpired ? (
                            ""
                          ) : (
                            <>
                              {row?.status ? (
                                <button
                                  className="purple_button"
                                  onClick={() =>
                                    handleShow(row?.index, row?.amount)
                                  }
                                >
                                  Withdraw
                                </button>
                              ) : (
                                <button className="simple_button">
                                  <svg
                                    class="theme-img light-img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                  >
                                    <path
                                      d="M11.6673 3.5L5.25065 9.91667L2.33398 7"
                                      stroke="#13151A"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  <svg
                                    class="theme-img dark-img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                  >
                                    <path
                                      d="M11.6673 3.5L5.25065 9.91667L2.33398 7"
                                      stroke="white"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Withdrawn
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal className="token" show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>
            Withdraw Liquidity
            <svg
              class="theme-img light-img svgclooose"
              xmlns="http://www.w3.org/2000/svg"
              onClick={handleClose}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              class="theme-img dark-img svgclooose"
              onClick={handleClose}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="one_modal">
            <div className="inner_side_modal">
              <h2>aMOUNT</h2>
              <h3>${withdrawalAmount}</h3>
            </div>
            <div className="inner_side_modal1">
              <button
                className="close"
                onClick={() => {
                  handleClose();
                }}
              >
                Close
              </button>
              <button
                className="Withdraw"
                onClick={() => {
                  handleShow1();
                  handleClose();
                }}
              >
                Withdraw
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="token" show={show1} onHide={handleClose1} centered>
        <Modal.Header>
          <Modal.Title>
            Withdraw Liquidity{" "}
            <svg
              class="theme-img light-img svgclooose"
              onClick={handleClose1}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              class="theme-img dark-img svgclooose"
              onClick={handleClose1}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="one_modal1">
            <div className="inner_side_modal111">
              <img
                src="\assets\playassets\qus.png"
                class="theme-img dark-img "
              />
              <img
                src="\assets\playassets\qust.png"
                class="theme-img light-img "
              />
              <h2>Are you sure?</h2>
              <h3>You want to withdraw liquidity?</h3>
            </div>
            <div className="inner_side_modal1">
              <button className="close" onClick={handleClose1}>
                Close
              </button>
              <button
                className="Withdraw"
                onClick={() => {
                  handleWidhrawl();
                }}
              >
                Yes i’m sure
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="token"
        show={show2}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>
            Success{" "}
            <svg
              class="theme-img light-img svgclooose"
              onClick={handleClose2}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              class="theme-img dark-img svgclooose"
              onClick={handleClose2}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="one_modal1">
            <div className="inner_side_modal111">
              <img
                src="\assets\playassets\tick.png"
                class="theme-img dark-img "
              />
              <img
                src="\assets\playassets\whitet.png"
                class="theme-img light-img "
              />
              <h2>Liquidity Successfully Withdrawn</h2>
              {/* <h3>You want to withdraw liquidity?</h3> */}
            </div>
            <div className="inner_side_modal1">
              <button className="close" onClick={handleClose2}>
                Close
              </button>
              {/* <button className='Withdraw' onClick={() => {
                    handleShow1();
                     handleClose2();
                  }}>Yes i’m sure</button> */}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="token" show={show3} onHide={handleClose3} centered>
        <Modal.Header>
          <Modal.Title>
            Remove Liquidity{" "}
            <svg
              class="theme-img light-img svgclooose"
              onClick={handleClose3}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              class="theme-img dark-img svgclooose"
              onClick={handleClose3}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="one_modal1">
            <div className="new_modals">
              <div className="liquid_textt">
                <h2>Liquidity</h2>
                <h2>
                  Your Liquidity Share:{" "}
                  {/* <span>${(+userLiquidity)?.toFixed(2)}</span> */}
                  <span>${(+currentUserLiquidity)?.toFixed(2)}</span>
                </h2>
              </div>
              <input
                value={removeUserLiquidity}
                placeholder="$0.00"
                type="text"
                id="fname"
                name="fname"
                onChange={(e) => removeLiquidityinputHandler(e)}
              />

              {errorStateRemove ? (
                <h4
                  style={{
                    marginTop: "10px",
                    color: "red",
                    fontSize: "12px",
                  }}
                >
                  Amount is 0 or Greater Than Available liquidity
                </h4>
              ) : (
                ""
              )}
              <h5>
                Any removed liquidity will be available <br></br> for withdrawal
                in 7 days
              </h5>
            </div>
            <div className="inner_side_modal1">
              <button className="close" onClick={handleClose3}>
                Close
              </button>
              <button
                className="remove"
                onClick={() => {
                  if (
                    // +removeUserLiquidity > +currentLiquidity

                    +removeUserLiquidity > +currentUserLiquidity ||
                    removeUserLiquidity <= 0
                  ) {
                    setErrorStateRemove(true);
                  } else {
                    handleShow4();
                    handleClose3();
                  }
                }}
              >
                Remove
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="token" show={show4} onHide={handleClose4} centered>
        <Modal.Header>
          <Modal.Title>
            Remove Liquidity{" "}
            <svg
              class="theme-img light-img svgclooose"
              onClick={handleClose4}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              class="theme-img dark-img svgclooose"
              onClick={handleClose4}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="one_modal1">
            <div className="inner_side_modal111">
              <img
                src="\assets\playassets\qus.png"
                class="theme-img dark-img "
              />
              <img
                src="\assets\playassets\qust.png"
                class="theme-img light-img "
              />
              <h2>Are you sure?</h2>
              <h3>You want to remove liquidity?</h3>
            </div>
            <div className="inner_side_modal1">
              <button className="close" onClick={handleClose4}>
                Close
              </button>
              <button className="Withdraw" onClick={handleRemoveLiquidity}>
                Yes i’m sure
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="token"
        show={show5}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>
            Success{" "}
            <svg
              class="theme-img light-img svgclooose"
              onClick={handleClose5}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              class="theme-img dark-img svgclooose"
              onClick={handleClose5}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="one_modal1">
            <div className="inner_side_modal111">
              <img
                src="\assets\playassets\tick.png"
                class="theme-img dark-img "
              />
              <img
                src="\assets\playassets\whitet.png"
                class="theme-img light-img "
              />
              <h2>Liquidity Successfully Removed</h2>
              <h5>Liquidity withdrawals will be available after 7 days.</h5>

              {/* <h3>You want to withdraw liquidity?</h3> */}
            </div>
            <div className="inner_side_modal1">
              <button className="close" onClick={handleClose5}>
                Close
              </button>
              {/* <button className='Withdraw' onClick={() => {
                    handleShow1();
                     handleClose2();
                  }}>Yes i’m sure</button> */}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="token" show={show6} onHide={handleClose6} centered>
        <Modal.Header>
          <Modal.Title>
            Add liquidity{" "}
            <svg
              class="theme-img light-img svgclooose"
              onClick={handleClose6}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              class="theme-img dark-img svgclooose"
              onClick={handleClose6}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="one_modal1">
            <div className="new_modals">
              <div className="liquid_textt">
                <h2>Amount</h2>
                <h2>
                  Balance: <span>${(+userBalance).toFixed(2)}</span>
                </h2>
              </div>
              <div className="relations">
                <input
                  placeholder="$0.00"
                  type="text"
                  id="fname"
                  className="liquidityinput"
                  name="fname"
                  value={liquidityAmount}
                  onChange={liquidityInputHandler}
                />
                <img
                  src="\assets\playassets\usdc.svg"
                  alt="img"
                  className="img-fluid neww_div"
                />
              </div>
              {errorState ? (
                <h4
                  style={{
                    marginTop: "10px",
                    color: "red",
                    fontSize: "12px",
                  }}
                >
                  Amount is 0 or Greater than Balance.
                </h4>
              ) : (
                ""
              )}
            </div>
            <div className="inner_side_modal1">
              <button className="close" onClick={handleClose6}>
                Close
              </button>
              <button
                className="Withdraw disabled"
                onClick={() => {
                  if (
                    +liquidityAmount > +userBalance ||
                    +liquidityAmount <= 0
                  ) {
                    setErrorState(true);
                  } else {
                    handleShow7();
                    handleClose6();
                  }
                }}
              >
                Add
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="token" show={show7} onHide={handleClose7} centered>
        <Modal.Header>
          <Modal.Title>
            Add liquidity{" "}
            <svg
              class="theme-img light-img svgclooose"
              onClick={handleClose7}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              class="theme-img dark-img svgclooose"
              onClick={handleClose7}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="one_modal1">
            <div className="inner_side_modal111">
              <img
                src="\assets\playassets\qus.png"
                class="theme-img dark-img "
              />
              <img
                src="\assets\playassets\qust.png"
                class="theme-img light-img "
              />
              <h2>Are you sure?</h2>
              <h3>You want to Add liquidity?</h3>
            </div>
            <div className="inner_side_modal1">
              <button className="close" onClick={handleClose7}>
                Close
              </button>
              <button className="Withdraw" onClick={handleAddLiquidity}>
                Yes i’m sure
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="token"
        show={show8}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>
            Success{" "}
            <svg
              class="theme-img light-img svgclooose"
              onClick={handleClose8}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              class="theme-img dark-img svgclooose"
              onClick={handleClose8}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="one_modal1">
            <div className="inner_side_modal111">
              <img
                src="\assets\playassets\tick.png"
                class="theme-img dark-img "
              />
              <img
                src="\assets\playassets\whitet.png"
                class="theme-img light-img "
              />
              <h2>Liquidity Successfully Added</h2>
              {/* <h3>You want to withdraw liquidity?</h3> */}
            </div>
            <div className="inner_side_modal1">
              <button className="close" onClick={handleClose8}>
                Close
              </button>
              {/* <button className='Withdraw' onClick={() => {
                    handleShow1();
                     handleClose2();
                  }}>Yes i’m sure</button> */}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="token" show={show9} onHide={handleClose9} centered>
        <Modal.Header>
          <Modal.Title>
            Claim Rewards{" "}
            <svg
              class="theme-img light-img svgclooose"
              onClick={() => {
                handleClose9();
              }}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              class="theme-img dark-img svgclooose"
              onClick={() => {
                handleClose9();
              }}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="one_modal">
            <div className="inner_side_modal">
              <h2>aMOUNT</h2>

              <h3>${(+userRewards).toFixed(2)}</h3>
            </div>
            <div className="inner_side_modal1">
              <button
                className="close"
                onClick={() => {
                  handleClose9();
                }}
                disabled={loading}
              >
                Close
              </button>
              <button
                className="Withdraw"
                onClick={handleClaimRewards}
                disabled={+userRewards === 0}
              >
                Claim
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="token"
        show={show10}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>
            Success{" "}
            <svg
              class="theme-img light-img svgclooose"
              onClick={handleClose10}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              class="theme-img dark-img svgclooose"
              onClick={handleClose10}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="one_modal1">
            <div className="inner_side_modal111">
              <img
                src="\assets\playassets\tick.png"
                class="theme-img dark-img "
              />
              <img
                src="\assets\playassets\whitet.png"
                class="theme-img light-img "
              />{" "}
              <h2>Rewards Successfully Claimed</h2>
              {/* <h3>You want to withdraw liquidity?</h3> */}
            </div>
            <div className="inner_side_modal1">
              <button className="close" onClick={handleClose10}>
                Close
              </button>
              {/* <button className='Withdraw' onClick={() => {
                    handleShow1();
                     handleClose2();
                  }}>Yes i’m sure</button> */}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="metamodal"
        show={show11}
        onHide={handleClose11}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Connect Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parentbox">
            <div className="mainbox d-noneformobile" onClick={connectWallet}>
              <p>
                {theme === "light" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="46"
                    height="46"
                    viewBox="0 0 46 46"
                    fill="none"
                  >
                    <rect
                      width="46"
                      height="46"
                      rx="23"
                      fill="black"
                      fill-opacity="0.1"
                    />
                    <path
                      d="M34.2691 11.8662L24.4785 19.0583L26.2992 14.8197L34.2691 11.8662Z"
                      fill="#E17726"
                      stroke="#E17726"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.686 11.8662L21.3894 19.1254L19.656 14.8197L11.686 11.8662Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M30.7437 28.542L28.1387 32.4928L33.7166 34.0176L35.3145 28.6284L30.7437 28.542Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.6494 28.6284L12.2376 34.0176L17.8059 32.4928L15.2106 28.542L10.6494 28.6284Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.506 21.868L15.9565 24.1887L21.4764 24.438L21.2924 18.5405L17.506 21.868Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M28.4489 21.8678L24.6044 18.4731L24.4785 24.4377L29.9983 24.1884L28.4489 21.8678Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.8062 32.4926L21.1471 30.8912L18.271 28.6665L17.8062 32.4926Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.8081 30.8912L28.1394 32.4926L27.6842 28.6665L24.8081 30.8912Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M28.1394 32.493L24.8081 30.8916L25.0792 33.0396L25.0501 33.9506L28.1394 32.493Z"
                      fill="#D5BFB2"
                      stroke="#D5BFB2"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.8062 32.493L20.9051 33.9506L20.8857 33.0396L21.1471 30.8916L17.8062 32.493Z"
                      fill="#D5BFB2"
                      stroke="#D5BFB2"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20.9635 27.2476L18.1938 26.4421L20.15 25.5503L20.9635 27.2476Z"
                      fill="#233447"
                      stroke="#233447"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.9917 27.2476L25.8052 25.5503L27.771 26.4421L24.9917 27.2476Z"
                      fill="#233447"
                      stroke="#233447"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.8062 32.4928L18.2905 28.542L15.2109 28.6284L17.8062 32.4928Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M27.6646 28.542L28.1391 32.4928L30.7441 28.6284L27.6646 28.542Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M29.9983 24.1885L24.4785 24.4378L24.9917 27.2476L25.8052 25.5502L27.7711 26.442L29.9983 24.1885Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.1935 26.442L20.1497 25.5502L20.9632 27.2476L21.4764 24.4378L15.9565 24.1885L18.1935 26.442Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.9565 24.1885L18.271 28.6667L18.1935 26.442L15.9565 24.1885Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M27.7712 26.442L27.6841 28.6667L29.9986 24.1885L27.7712 26.442Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M21.4767 24.438L20.9634 27.2477L21.6122 30.5656L21.7575 26.1929L21.4767 24.438Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.4787 24.438L24.2075 26.1833L24.3431 30.5656L24.9919 27.2477L24.4787 24.438Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.9916 27.2474L24.3428 30.5653L24.8076 30.8914L27.6838 28.6666L27.7709 26.4419L24.9916 27.2474Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.1938 26.4419L18.2714 28.6666L21.1475 30.8914L21.6123 30.5653L20.9635 27.2474L18.1938 26.4419Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M25.0498 33.9508L25.0788 33.0398L24.8271 32.8288H21.1278L20.8857 33.0398L20.9051 33.9508L17.8062 32.4932L18.8908 33.3754L21.089 34.8809H24.8561L27.064 33.3754L28.1389 32.4932L25.0498 33.9508Z"
                      fill="#C0AC9D"
                      stroke="#C0AC9D"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.8077 30.8914L24.3429 30.5654H21.612L21.1472 30.8914L20.8857 33.0395L21.1279 32.8285H24.8271L25.0789 33.0395L24.8077 30.8914Z"
                      fill="#161616"
                      stroke="#161616"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M34.6857 19.5281L35.5089 15.5581L34.2693 11.8662L24.8081 18.8185L28.4492 21.8679L33.5914 23.3543L34.7245 22.0406L34.2306 21.6857L35.015 20.9762L34.4146 20.5159L35.199 19.9213L34.6857 19.5281Z"
                      fill="#763E1A"
                      stroke="#763E1A"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.4463 15.5581L11.2791 19.5281L10.7465 19.9213L11.5406 20.5159L10.9402 20.9762L11.7246 21.6857L11.2307 22.0406L12.3637 23.3543L17.506 21.8679L21.1471 18.8185L11.6858 11.8662L10.4463 15.5581Z"
                      fill="#763E1A"
                      stroke="#763E1A"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M33.5913 23.3545L28.4491 21.8682L29.9986 24.1888L27.6841 28.667L30.7442 28.6287H35.315L33.5913 23.3545Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.5056 21.8682L12.3635 23.3545L10.6494 28.6287H15.2106L18.2707 28.667L15.9562 24.1888L17.5056 21.8682Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.4784 24.438L24.8076 18.8186L26.299 14.8198H19.6558L21.1471 18.8186L21.4763 24.438L21.6022 26.2024L21.6119 30.5656H24.3428L24.3525 26.2024L24.4784 24.438Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="46"
                    height="46"
                    viewBox="0 0 46 46"
                    fill="none"
                  >
                    <rect
                      width="46"
                      height="46"
                      rx="23"
                      fill="white"
                      fill-opacity="0.08"
                    />
                    <path
                      d="M34.2691 11.8663L24.4785 19.0583L26.2992 14.8198L34.2691 11.8663Z"
                      fill="#E17726"
                      stroke="#E17726"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.686 11.8663L21.3894 19.1254L19.656 14.8198L11.686 11.8663Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M30.7437 28.5421L28.1387 32.493L33.7166 34.0177L35.3145 28.6285L30.7437 28.5421Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.6494 28.6285L12.2376 34.0177L17.8059 32.493L15.2106 28.5421L10.6494 28.6285Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.506 21.868L15.9565 24.1887L21.4764 24.438L21.2924 18.5405L17.506 21.868Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M28.4489 21.8681L24.6044 18.4734L24.4785 24.4381L29.9983 24.1887L28.4489 21.8681Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.8062 32.4929L21.1471 30.8916L18.271 28.6668L17.8062 32.4929Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.8081 30.8916L28.1394 32.4929L27.6842 28.6668L24.8081 30.8916Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M28.1394 32.4931L24.8081 30.8917L25.0792 33.0397L25.0501 33.9507L28.1394 32.4931Z"
                      fill="#D5BFB2"
                      stroke="#D5BFB2"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.8062 32.4931L20.9051 33.9507L20.8857 33.0397L21.1471 30.8917L17.8062 32.4931Z"
                      fill="#D5BFB2"
                      stroke="#D5BFB2"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20.9635 27.2476L18.1938 26.4421L20.15 25.5503L20.9635 27.2476Z"
                      fill="#233447"
                      stroke="#233447"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.9917 27.2476L25.8052 25.5503L27.771 26.4421L24.9917 27.2476Z"
                      fill="#233447"
                      stroke="#233447"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.8062 32.493L18.2905 28.5421L15.2109 28.6285L17.8062 32.493Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M27.6646 28.5421L28.1391 32.493L30.7441 28.6285L27.6646 28.5421Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M29.9983 24.1885L24.4785 24.4379L24.9917 27.2476L25.8052 25.5502L27.7711 26.4421L29.9983 24.1885Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.1935 26.4421L20.1497 25.5502L20.9632 27.2476L21.4764 24.4379L15.9565 24.1885L18.1935 26.4421Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.9565 24.1885L18.271 28.6668L18.1935 26.4421L15.9565 24.1885Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M27.7712 26.4421L27.6841 28.6668L29.9986 24.1885L27.7712 26.4421Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M21.4767 24.4379L20.9634 27.2476L21.6122 30.5655L21.7575 26.1928L21.4767 24.4379Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.4787 24.4379L24.2075 26.1832L24.3431 30.5655L24.9919 27.2476L24.4787 24.4379Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.9916 27.2477L24.3428 30.5656L24.8076 30.8917L27.6838 28.6669L27.7709 26.4422L24.9916 27.2477Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.1938 26.4422L18.2714 28.6669L21.1475 30.8917L21.6123 30.5656L20.9635 27.2477L18.1938 26.4422Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M25.0498 33.9506L25.0788 33.0396L24.8271 32.8287H21.1278L20.8857 33.0396L20.9051 33.9506L17.8062 32.493L18.8908 33.3753L21.089 34.8808H24.8561L27.064 33.3753L28.1389 32.493L25.0498 33.9506Z"
                      fill="#C0AC9D"
                      stroke="#C0AC9D"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.8077 30.8915L24.3429 30.5656H21.612L21.1472 30.8915L20.8857 33.0396L21.1279 32.8286H24.8271L25.0789 33.0396L24.8077 30.8915Z"
                      fill="#161616"
                      stroke="#161616"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M34.6857 19.5282L35.5089 15.5582L34.2693 11.8663L24.8081 18.8186L28.4492 21.868L33.5914 23.3544L34.7245 22.0406L34.2306 21.6858L35.015 20.9762L34.4146 20.5159L35.199 19.9214L34.6857 19.5282Z"
                      fill="#763E1A"
                      stroke="#763E1A"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.4463 15.5582L11.2791 19.5282L10.7465 19.9214L11.5406 20.5159L10.9402 20.9762L11.7246 21.6858L11.2307 22.0406L12.3637 23.3544L17.506 21.868L21.1471 18.8186L11.6858 11.8663L10.4463 15.5582Z"
                      fill="#763E1A"
                      stroke="#763E1A"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M33.5913 23.3543L28.4491 21.868L29.9986 24.1886L27.6841 28.6668L30.7442 28.6285H35.315L33.5913 23.3543Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.5056 21.868L12.3635 23.3543L10.6494 28.6285H15.2106L18.2707 28.6668L15.9562 24.1886L17.5056 21.868Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.4784 24.4379L24.8076 18.8185L26.299 14.8198H19.6558L21.1471 18.8185L21.4763 24.4379L21.6022 26.2024L21.6119 30.5656H24.3428L24.3525 26.2024L24.4784 24.4379Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                )}
                MetaMask
              </p>
            </div>
            <div className="mainbox">
              <p
                onClick={() => {
                  trustWallet();
                  handleClose();
                }}
              >
                {theme === "light" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="46"
                    height="46"
                    viewBox="0 0 46 46"
                    fill="none"
                  >
                    <path
                      d="M0 23C0 10.2975 10.2975 0 23 0C35.7025 0 46 10.2975 46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23Z"
                      fill="black"
                      fill-opacity="0.06"
                    />
                    <path
                      d="M14.5135 17.8214C19.003 13.428 26.2797 13.428 30.7691 17.8214L31.3086 18.3515C31.5318 18.5717 31.5318 18.9282 31.3086 19.1483L29.4608 20.9559C29.3491 21.0644 29.1662 21.0644 29.0546 20.9559L28.3105 20.2273C25.179 17.1641 20.1005 17.1641 16.9691 20.2273L16.1723 21.0055C16.0607 21.114 15.8777 21.114 15.7661 21.0055L13.9183 19.1979C13.695 18.9778 13.695 18.6213 13.9183 18.4011L14.5104 17.8214H14.5135ZM34.592 21.5605L36.2352 23.1696C36.4584 23.3897 36.4584 23.7463 36.2352 23.9664L28.819 31.2245C28.5957 31.4447 28.2299 31.4447 28.0066 31.2245L22.7421 26.0747C22.6863 26.0189 22.5964 26.0189 22.5375 26.0747L17.2729 31.2245C17.0497 31.4447 16.6839 31.4447 16.4606 31.2245L9.04438 23.9664C8.82115 23.7463 8.82115 23.3897 9.04438 23.1696L10.6876 21.5605C10.9108 21.3404 11.2767 21.3404 11.4999 21.5605L16.7645 26.7103C16.8203 26.7661 16.9102 26.7661 16.9691 26.7103L22.2336 21.5605C22.4569 21.3404 22.8227 21.3404 23.0459 21.5605L28.3105 26.7134C28.3663 26.7692 28.4562 26.7692 28.5151 26.7134L33.7797 21.5636C34.0029 21.3435 34.3687 21.3435 34.592 21.5636V21.5605Z"
                      fill="#3999FD"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="46"
                    height="46"
                    viewBox="0 0 46 46"
                    fill="none"
                  >
                    <path
                      d="M0 23C0 10.2975 10.2975 0 23 0C35.7025 0 46 10.2975 46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23Z"
                      fill="white"
                      fill-opacity="0.08"
                    />
                    <path
                      d="M14.5135 17.8213C19.003 13.428 26.2797 13.428 30.7691 17.8213L31.3086 18.3515C31.5318 18.5716 31.5318 18.9282 31.3086 19.1483L29.4608 20.9558C29.3491 21.0644 29.1662 21.0644 29.0546 20.9558L28.3105 20.2272C25.179 17.164 20.1005 17.164 16.9691 20.2272L16.1723 21.0054C16.0607 21.114 15.8777 21.114 15.7661 21.0054L13.9183 19.1979C13.695 18.9778 13.695 18.6212 13.9183 18.4011L14.5104 17.8213H14.5135ZM34.592 21.5604L36.2352 23.1695C36.4584 23.3897 36.4584 23.7462 36.2352 23.9664L28.819 31.2245C28.5957 31.4446 28.2299 31.4446 28.0066 31.2245L22.7421 26.0747C22.6863 26.0188 22.5964 26.0188 22.5375 26.0747L17.2729 31.2245C17.0497 31.4446 16.6839 31.4446 16.4606 31.2245L9.04438 23.9664C8.82115 23.7462 8.82115 23.3897 9.04438 23.1695L10.6876 21.5604C10.9108 21.3403 11.2767 21.3403 11.4999 21.5604L16.7645 26.7102C16.8203 26.7661 16.9102 26.7661 16.9691 26.7102L22.2336 21.5604C22.4569 21.3403 22.8227 21.3403 23.0459 21.5604L28.3105 26.7133C28.3663 26.7692 28.4562 26.7692 28.5151 26.7133L33.7797 21.5635C34.0029 21.3434 34.3687 21.3434 34.592 21.5635V21.5604Z"
                      fill="#3999FD"
                    />
                  </svg>
                )}
                WalletConnect
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Liquidity;
